import { Box, Pagination } from '@mui/material';
import React from 'react';

const CustomPagination = ({
    currentPage,
    totalPages,
    onPageChange,
    size = "small",
    color = "primary",
    sx = {}
}) => {
    if (totalPages <= 1) return null;

    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            mt: 2,
            mb: 1,
            ...sx
        }}>
            <Pagination
                count={totalPages}
                page={currentPage}
                onChange={onPageChange}
                color={color}
                size={size}
                sx={{
                    '& .MuiPaginationItem-root': {
                        fontSize: '0.75rem',
                        minWidth: '28px',
                        height: '28px',
                    },
                }}
            />
        </Box>
    );
};

export default CustomPagination; 